import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeExchangeRateCommand extends BaseCommand {
  CommandName = "ChangeExchangeRate";
  Command: {
    ExchangeRate: number;
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, exchangeRate: number) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId, ExchangeRate: exchangeRate };
  }
}
